var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.0846C28 6.30662 21.7312 0 14 0C6.26875 0 0 6.30662 0 14.0846C0 21.1143 5.11875 26.9411 11.8125 27.9987V18.1571H8.25687V14.0846H11.8125V10.9816C11.8125 7.45225 13.9031 5.50116 17.1006 5.50116C18.6325 5.50116 20.235 5.77656 20.235 5.77656V9.243H18.4688C16.7306 9.243 16.1869 10.3283 16.1869 11.4437V14.0846H20.0694L19.4494 18.1571H16.1875V28C22.8812 26.943 28 21.1162 28 14.0846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo-facebook.9fe4e2683dfe2b642c1398e3680278a9.svg";
export { ForwardRef as ReactComponent };